import React from "react";
import callerimage from "../../assets/photos/phoneicon.png";

// card in admin which displays individual visitor information, takes values from props

const Admincard = (props) => {
  return (
    <div className="card-structure">
      <div className="card-content-name">{props.name}</div>
      <div className="card-content-email">{props.email}</div>
      <div className="card-content-phonenumber">
        <img src={callerimage} width="15px" height="15px" />
        <span className="card-content-phonenumber-text">{props.phone}</span>
      </div>
      <div className="card-content-visited">
        Visited on <i>{props.last}</i>
      </div>
    </div>
  );
};

export default Admincard;
